import LoggedInUser from './LoggedInUser';
import Helpers from './Helpers';

export function active_talents(limit, offset,profile_type) {
  return fetch(Helpers.endpoint("/admin_active_talents"), {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      auth_token: LoggedInUser.getInfo().auth_token, 
      profile_type: profile_type
    })
  }).then((response) => response.json())

}
